"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var VisitRecord = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.VISIT],
  objectType: _ObjectTypes.VISIT,
  recordName: 'VisitRecord',
  defaults: {
    domain: null,
    domainHash: null,
    firstTimestamp: null,
    lastBidenTimestamp: null,
    lastTimestamp: null,
    numPageViews: 0,
    numVids: 0,
    organization: null,
    originalSource: null,
    portalId: null,
    properties: (0, _immutable.Map)()
  }
}, {
  primary: ['name'],
  secondary: ['domain']
});
var _fromJS = VisitRecord.fromJS;

VisitRecord.fromJS = function (json) {
  if (json === null || json === undefined) {
    return json;
  }

  var immutable = (0, _immutable.fromJS)(json);

  if (immutable.has('properties')) {
    immutable = immutable.update('properties', function (properties) {
      properties = properties.reduce(function (map, property) {
        return map.set(property.get('name'), property);
      }, (0, _immutable.Map)()); // A bunch of data, including domain, are not a properties

      return _immutable.List.of('domain').reduce(function (map, property) {
        return map.set(property, (0, _immutable.Map)({
          name: property,
          value: immutable.get(property)
        }));
      }, properties);
    });
  }

  return _fromJS(immutable);
};

var _default = VisitRecord;
exports.default = _default;
module.exports = exports.default;